/**
 * Do not edit directly
 * Generated on Tue, 01 Apr 2025 14:12:35 GMT
 */

module.exports = {
  "color": {
    "global": {
      "gray": {
        "100": "#FAFAFA",
        "200": "#E6E6E6",
        "300": "#B4B5B5",
        "400": "#515151",
        "500": "#060707"
      },
      "white": {
        "white": "#FFFFFF"
      },
      "blue": {
        "100": "#EAEAFC",
        "300": "#C1BFF7",
        "500": "#2F29E5",
        "700": "#211DA0"
      },
      "red": {
        "100": "#F8E7EA",
        "300": "#EBB8C1",
        "500": "#A30015",
        "700": "#840D21"
      },
      "orange": {
        "100": "#FFF6EA",
        "300": "#FFE5C1",
        "500": "#FEA82F",
        "700": "#7F5418"
      },
      "green": {
        "100": "#E6F5F2",
        "300": "#B4E0D9",
        "500": "#059980",
        "700": "#046B5A"
      },
      "pink": {
        "100": "#FFECF3",
        "300": "#FFC7DC",
        "500": "#FF4389"
      }
    },
    "text": {
      "default": "#060707",
      "on-color": "#FFFFFF",
      "subtle": "#515151",
      "subtle-on-color": "#B4B5B5",
      "helper": "#515151",
      "placeholder": "#B4B5B5",
      "disabled": "#B4B5B5",
      "negative": "#A30015",
      "negative-hover": "#840D21",
      "interactive": "#2F29E5",
      "positive": "#059980",
      "warning": "#FEA82F"
    },
    "background": {
      "page": "#FAFAFA",
      "primary": "#FFFFFF",
      "inverse": "#060707",
      "disabled": "#E6E6E6",
      "hover": "#b4b5b533",
      "active": "#b4b5b54d",
      "overlay": "#0607074d",
      "interactive": "#2F29E5",
      "brand": "#FFECF3"
    },
    "border": {
      "subtle": "#E6E6E6",
      "strong": "#B4B5B5",
      "interactive": "#2F29E5",
      "disabled": "#E6E6E6",
      "inverse": "#060707",
      "negative": "#A30015",
      "positive": "#059980"
    },
    "link": {
      "default": "#2F29E5",
      "hover": "#211DA0",
      "focused": "#211DA0",
      "disabled": "#B4B5B5"
    },
    "icon": {
      "default": "#060707",
      "disabled": "#E6E6E6",
      "on-color": "#FFFFFF",
      "subtle": "#B4B5B5",
      "on-color-disabled": "#B4B5B5",
      "neutral-hover": "#211DA0",
      "neutral": "#2F29E5",
      "negative": "#A30015",
      "negative-hover": "#840D21",
      "positive": "#059980",
      "warning": "#FEA82F",
      "brand": "#FF4389"
    },
    "button": {
      "background-primary-default": "#060707",
      "background-primary-hover": "#515151",
      "background-primary-focused": "#515151",
      "background-primary-negative": "#A30015",
      "background-primary-disabled": "#B4B5B5",
      "background-primary-negative-hover": "#840D21",
      "background-primary-negative-focused": "#840D21",
      "background-primary-negative-disabled": "#EBB8C1",
      "background-secondary-default": "#FFFFFF",
      "background-secondary-disabled": "#FFFFFF",
      "background-secondary-hover": "#FAFAFA",
      "background-secondary-focused": "#E6E6E6",
      "border-secondary-default": "#060707",
      "border-secondary-hover": "#B4B5B5",
      "border-secondary-focused": "#515151",
      "border-secondary-disabled": "#E6E6E6",
      "background-secondary-negative": "#FFFFFF",
      "background-secondary-negative-hover": "#F8E7EA",
      "background-secondary-negative-focused": "#EBB8C1",
      "background-secondary-negative-disabled": "#FFFFFF",
      "border-secondary-negative": "#A30015",
      "border-secondary-negative-hover": "#840D21",
      "border-secondary-negative-focused": "#840D21",
      "border-secondary-negative-disabled": "#EBB8C1",
      "background-tertiary-default": "#ffffff00",
      "background-tertiary-hover": "#FAFAFA",
      "background-tertiary-focused": "#E6E6E6",
      "background-tertiary-disabled": "#FAFAFA"
    },
    "field": {
      "background-default": "#FFFFFF",
      "border-default": "#B4B5B5",
      "background-hover": "#FAFAFA",
      "border-hover": "#B4B5B5",
      "background-active": "#FFFFFF",
      "border-active": "#060707",
      "background-error": "#FFFFFF",
      "border-error": "#A30015",
      "background-disabled": "#E6E6E6",
      "border-disabled": "#E6E6E6",
      "background-read-only": "#E6E6E6",
      "border-read-only": "#E6E6E6",
      "background-warning": "#FFFFFF",
      "border-warning": "#FEA82F"
    },
    "control": {
      "background-default": "#FFFFFF",
      "border-default": "#515151",
      "background-hover": "#FFFFFF",
      "border-hover": "#2F29E5",
      "background-selected": "#2F29E5",
      "border-selected": "#2F29E5",
      "background-error": "#FFFFFF",
      "border-error": "#A30015",
      "background-disabled": "#FFFFFF",
      "border-disabled": "#B4B5B5",
      "background-read-only": "#FFFFFF",
      "border-read-only": "#B4B5B5",
      "background-interactive": "#2F29E5",
      "border-interactive": "#2F29E5",
      "background-interactive-hover": "#2F29E5",
      "border-interactive-hover": "#2F29E5",
      "background-interactive-error": "#A30015",
      "border-interactive-error": "#A30015",
      "background-interactive-disabled": "#C1BFF7",
      "border-interactive-disabled": "#C1BFF7",
      "background-interactive-read-only": "#C1BFF7",
      "border-interactive-read-only": "#C1BFF7",
      "background-secondary": "#B4B5B5"
    },
    "tag": {
      "background-positive": "#E6F5F2",
      "text-positive": "#046B5A",
      "border-positive": "#046B5A",
      "background-warning": "#FFF6EA",
      "text-warning": "#7F5418",
      "border-warning": "#7F5418",
      "background-negative": "#F8E7EA",
      "text-negative": "#840D21",
      "border-negative": "#840D21",
      "background-neutral": "#E6E6E6",
      "text-neutral": "#060707",
      "border-neutral": "#060707",
      "background-info": "#EAEAFC",
      "text-info": "#2F29E5",
      "border-info": "#2F29E5"
    },
    "dropdown-button": {
      "background-default": "#FFFFFF",
      "background-hover": "#b4b5b533"
    },
    "inline-notification": {
      "background-warning": "#FFF6EA",
      "title-warning": "#060707",
      "description-warning": "#060707",
      "border-warning": "#FEA82F",
      "bar-warning": "#FEA82F",
      "background-negative": "#F8E7EA",
      "title-negative": "#060707",
      "description-negative": "#060707",
      "border-negative": "#A30015",
      "bar-negative": "#A30015",
      "background-neutral": "#EAEAFC",
      "title-neutral": "#060707",
      "description-neutral": "#060707",
      "border-neutral": "#2F29E5",
      "bar-neutral": "#2F29E5"
    },
    "banner-notification": {
      "background-warning": "#FFF6EA",
      "title-warning": "#060707",
      "description-warning": "#060707",
      "border-warning": "#FEA82F",
      "bar-warning": "#FEA82F",
      "background-negative": "#F8E7EA",
      "title-negative": "#060707",
      "description-negative": "#060707",
      "border-negative": "#A30015",
      "bar-negative": "#A30015",
      "background-neutral": "#EAEAFC",
      "title-neutral": "#060707",
      "description-neutral": "#060707",
      "border-neutral": "#2F29E5",
      "bar-neutral": "#2F29E5"
    },
    "toast-notification": {
      "background-positive": "#FFFFFF",
      "title-positive": "#060707",
      "description-positive": "#515151",
      "icon-background-positive": "#E6F5F2",
      "bar-positive": "#059980",
      "background-warning": "#FFFFFF",
      "title-warning": "#060707",
      "description-warning": "#515151",
      "icon-background-warning": "#FFF6EA",
      "bar-warning": "#FEA82F",
      "background-negative": "#FFFFFF",
      "title-negative": "#060707",
      "description-negative": "#515151",
      "icon-background-negative": "#F8E7EA",
      "bar-negative": "#A30015"
    },
    "table": {
      "row-background-hover": "#eaeafc4d",
      "row-background-primary": "#FFFFFF",
      "row-background-secondary": "#FAFAFA",
      "row-background-selected": "#EAEAFC",
      "row-title-border": "#E6E6E6"
    },
    "toggle-button": {
      "background-default": "#ffffff00",
      "background-hover": "#b4b5b533",
      "background-selected": "#2F29E5",
      "border-default": "#2F29E5"
    },
    "breadcrumb": {
      "text-default": "#515151",
      "text-hover": "#211DA0",
      "text-active": "#060707"
    },
    "navigation": {
      "menu-background-default": "#FFFFFF",
      "navitem": {
        "background-primary-default": "#FFFFFF",
        "background-primary-active": "#EAEAFC",
        "background-primary-hover": "#EAEAFC",
        "background-secondary-default": "#FAFAFA",
        "background-secondary-hover": "#EAEAFC",
        "background-secondary-active": "#FAFAFA",
        "text-primary-default": "#060707",
        "text-primary-hover": "#060707",
        "text-primary-active": "#060707",
        "text-secondary-default": "#515151",
        "text-secondary-hover": "#060707",
        "text-secondary-active": "#2F29E5",
        "icon-primary-default": "#B4B5B5"
      }
    },
    "card": {
      "background-primary-default": "#FFFFFF",
      "background-primary-hover": "#FFFFFF",
      "background-primary-selected": "#FFFFFF",
      "background-primary-nonselected": "#FFFFFF",
      "background-primary-disabled": "#FFFFFF",
      "border-primary-default": "#E6E6E6",
      "border-primary-hover": "#2F29E5",
      "border-primary-selected": "#2F29E5",
      "border-primary-nonselected": "#E6E6E6",
      "border-primary-disabled": "#E6E6E6",
      "background-secondary-default": "#FFFFFF",
      "background-secondary-hover": "#EAEAFC",
      "background-secondary-selected": "#EAEAFC",
      "background-secondary-nonselected": "#FFFFFF",
      "background-secondary-disabled": "#E6E6E6",
      "border-secondary-default": "#FFFFFF",
      "border-secondary-hover": "#EAEAFC",
      "border-secondary-selected": "#EAEAFC",
      "border-secondary-nonselected": "#FFFFFF",
      "border-secondary-disabled": "#E6E6E6"
    }
  },
  "spacing": {
    "0": "0rem",
    "4": "0.25rem",
    "8": "0.5rem",
    "12": "0.75rem",
    "16": "1rem",
    "24": "1.5rem",
    "32": "2rem",
    "64": "4rem"
  },
  "borderRadius": {
    "s": "0.25rem",
    "m": "0.5rem",
    "full": "31.25rem"
  },
  "borderWidth": {
    "s": "0.0625rem",
    "m": "0.125rem",
    "xl": "0.5rem"
  },
  "opacity": {
    "0": "10%",
    "1": "20%",
    "2": "30%"
  },
  "shadow": {
    "s": {
      "x": "0rem",
      "y": "0.125rem",
      "blur": "0.25rem",
      "spread": "0rem",
      "color": "#0607074d",
      "type": "dropShadow"
    },
    "m": {
      "x": "0rem",
      "y": "0.125rem",
      "blur": "1rem",
      "spread": "0rem",
      "color": "#06070733",
      "type": "dropShadow"
    },
    "l": {
      "x": "0rem",
      "y": "1rem",
      "blur": "2rem",
      "spread": "0rem",
      "color": "#0607074d",
      "type": "dropShadow"
    }
  },
  "lineHeight": {
    "0": "1rem",
    "1": "1.5rem",
    "2": "2rem",
    "3": "2.5rem",
    "4": "3.5rem",
    "5": "4.5rem",
    "6": "5rem",
    "7": "6rem"
  },
  "fontSize": {
    "0": "0.75rem",
    "1": "0.875rem",
    "2": "1rem",
    "3": "1.25rem",
    "4": "1.5rem",
    "5": "2rem",
    "6": "2.5rem",
    "7": "3rem",
    "8": "3.5rem",
    "9": "4rem"
  },
  "letterSpacing": {
    "0": "0rem"
  },
  "fontFamily": {
    "primary": "TT Norms Pro"
  },
  "fontWeight": {
    "400": 400,
    "500": 500,
    "700": 700
  },
  "textCase": {
    "none": "none"
  },
  "textDecoration": {
    "none": "none",
    "underline": "underline"
  },
  "sizing": {
    "0": "0rem",
    "8": "0.5rem",
    "16": "1rem",
    "24": "1.5rem",
    "32": "2rem",
    "40": "2.5rem",
    "64": "4rem",
    "128": "8rem"
  },
  "breakpoint": {
    "mobile": "30em",
    "tablet": "48em",
    "laptop": "64em",
    "desktop": "80em",
    "highres": "90em"
  },
  "paragraphSpacing": {
    "0": "0.5rem",
    "1": "1rem",
    "2": "1.5rem",
    "3": "2rem"
  },
  "heading": {
    "20": {
      "regular": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 400,
        "lineHeight": "2rem",
        "fontSize": "1.25rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "0.5rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "medium": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 500,
        "lineHeight": "2rem",
        "fontSize": "1.25rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "0.5rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "bold": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 700,
        "lineHeight": "2rem",
        "fontSize": "1.25rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "0.5rem",
        "textCase": "none",
        "textDecoration": "none"
      }
    },
    "24": {
      "regular": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 400,
        "lineHeight": "2rem",
        "fontSize": "1.5rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "medium": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 500,
        "lineHeight": "2rem",
        "fontSize": "1.5rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "bold": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 700,
        "lineHeight": "2rem",
        "fontSize": "1.5rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1rem",
        "textCase": "none",
        "textDecoration": "none"
      }
    },
    "32": {
      "regular": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 400,
        "lineHeight": "2.5rem",
        "fontSize": "2rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "medium": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 500,
        "lineHeight": "2.5rem",
        "fontSize": "2rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "bold": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 700,
        "lineHeight": "2.5rem",
        "fontSize": "2rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1rem",
        "textCase": "none",
        "textDecoration": "none"
      }
    },
    "48": {
      "regular": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 400,
        "lineHeight": "4.5rem",
        "fontSize": "3rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1.5rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "medium": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 500,
        "lineHeight": "4.5rem",
        "fontSize": "3rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1.5rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "bold": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 700,
        "lineHeight": "4.5rem",
        "fontSize": "3rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1.5rem",
        "textCase": "none",
        "textDecoration": "none"
      }
    },
    "64": {
      "regular": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 400,
        "lineHeight": "6rem",
        "fontSize": "4rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "2rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "medium": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 500,
        "lineHeight": "6rem",
        "fontSize": "4rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "2rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "bold": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 700,
        "lineHeight": "6rem",
        "fontSize": "4rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "2rem",
        "textCase": "none",
        "textDecoration": "none"
      }
    }
  },
  "text": {
    "12": {
      "regular": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 400,
        "lineHeight": "1rem",
        "fontSize": "0.75rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "0.5rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "medium": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 500,
        "lineHeight": "1rem",
        "fontSize": "0.75rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "0.5rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "bold": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 700,
        "lineHeight": "1rem",
        "fontSize": "0.75rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "0.5rem",
        "textCase": "none",
        "textDecoration": "none"
      }
    },
    "14": {
      "regular": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 400,
        "lineHeight": "1.5rem",
        "fontSize": "0.875rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "0.5rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "medium": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 500,
        "lineHeight": "1.5rem",
        "fontSize": "0.875rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "0.5rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "bold": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 700,
        "lineHeight": "1.5rem",
        "fontSize": "0.875rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "0.5rem",
        "textCase": "none",
        "textDecoration": "none"
      }
    },
    "16": {
      "regular": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 400,
        "lineHeight": "1.5rem",
        "fontSize": "1rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "0.5rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "medium": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 500,
        "lineHeight": "1.5rem",
        "fontSize": "1rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "0.5rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "bold": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 700,
        "lineHeight": "1.5rem",
        "fontSize": "1rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "0.5rem",
        "textCase": "none",
        "textDecoration": "none"
      }
    },
    "20": {
      "regular": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 400,
        "lineHeight": "2rem",
        "fontSize": "1.25rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "0.5rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "medium": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 500,
        "lineHeight": "2rem",
        "fontSize": "1.25rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "0.5rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "bold": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 700,
        "lineHeight": "2rem",
        "fontSize": "1.25rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "0.5rem",
        "textCase": "none",
        "textDecoration": "none"
      }
    },
    "24": {
      "regular": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 400,
        "lineHeight": "2rem",
        "fontSize": "1.5rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "medium": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 500,
        "lineHeight": "2rem",
        "fontSize": "1.5rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "bold": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 700,
        "lineHeight": "2rem",
        "fontSize": "1.5rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1rem",
        "textCase": "none",
        "textDecoration": "none"
      }
    },
    "32": {
      "regular": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 400,
        "lineHeight": "2.5rem",
        "fontSize": "2rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "medium": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 500,
        "lineHeight": "2.5rem",
        "fontSize": "2rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "bold": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 700,
        "lineHeight": "2.5rem",
        "fontSize": "2rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1rem",
        "textCase": "none",
        "textDecoration": "none"
      }
    },
    "40": {
      "regular": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 400,
        "lineHeight": "3.5rem",
        "fontSize": "2.5rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1.5rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "medium": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 500,
        "lineHeight": "3.5rem",
        "fontSize": "2.5rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1.5rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "bold": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 700,
        "lineHeight": "3.5rem",
        "fontSize": "2.5rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1.5rem",
        "textCase": "none",
        "textDecoration": "none"
      }
    },
    "48": {
      "regular": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 400,
        "lineHeight": "4.5rem",
        "fontSize": "3rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1.5rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "medium": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 500,
        "lineHeight": "4.5rem",
        "fontSize": "3rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1.5rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "bold": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 700,
        "lineHeight": "4.5rem",
        "fontSize": "3rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "1.5rem",
        "textCase": "none",
        "textDecoration": "none"
      }
    },
    "56": {
      "regular": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 400,
        "lineHeight": "5rem",
        "fontSize": "3.5rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "2rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "medium": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 500,
        "lineHeight": "5rem",
        "fontSize": "3.5rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "2rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "bold": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 700,
        "lineHeight": "5rem",
        "fontSize": "3.5rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "2rem",
        "textCase": "none",
        "textDecoration": "none"
      }
    },
    "64": {
      "regular": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 400,
        "lineHeight": "6rem",
        "fontSize": "4rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "2rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "medium": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 500,
        "lineHeight": "6rem",
        "fontSize": "4rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "2rem",
        "textCase": "none",
        "textDecoration": "none"
      },
      "bold": {
        "fontFamily": "TT Norms Pro",
        "fontWeight": 700,
        "lineHeight": "6rem",
        "fontSize": "4rem",
        "letterSpacing": "0rem",
        "paragraphSpacing": "2rem",
        "textCase": "none",
        "textDecoration": "none"
      }
    }
  },
  "asset": {
    "font": {
      "TT Norms Pro": {
        "400": {
          "normal": "assets/fonts/TTNormsPro/TTNormsPro-Regular",
          "italic": "assets/fonts/TTNormsPro/TTNormsPro-Italic"
        },
        "500": {
          "normal": "assets/fonts/TTNormsPro/TTNormsPro-Medium",
          "italic": "assets/fonts/TTNormsPro/TTNormsPro-MediumItalic"
        },
        "600": {
          "normal": "assets/fonts/TTNormsPro/TTNormsPro-Bold",
          "italic": "assets/fonts/TTNormsPro/TTNormsPro-BoldItalic"
        }
      }
    }
  }
};